import { render, staticRenderFns } from "./ImgTurnPage.vue?vue&type=template&id=6d18f7a4&scoped=true&"
import script from "./ImgTurnPage.vue?vue&type=script&lang=js&"
export * from "./ImgTurnPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d18f7a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d18f7a4')) {
      api.createRecord('6d18f7a4', component.options)
    } else {
      api.reload('6d18f7a4', component.options)
    }
    module.hot.accept("./ImgTurnPage.vue?vue&type=template&id=6d18f7a4&scoped=true&", function () {
      api.rerender('6d18f7a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/ImgTurnPage.vue"
export default component.exports